import { api } from '../services/api';

// cliente_id e resolvido pelo backend a partir do JWT (get_cliente_id_from_jwt
// em secao_cliente.py). PR #569 deixou de aceitar cliente_id na query string.
export const useClienteKanban = () => {
  const token = localStorage.getItem('cliente_access_token');
  const headers = { Authorization: `Bearer ${token}` };

  const getBoard = async (eventoId: number) => {
    const res = await api.get(`/api/v1/secao-cliente/eventos/${eventoId}/kanban`, {
      headers,
    });
    return res.data;
  };

  const moveCard = async (data: {
    eventoId: number;
    cardId: number;
    column_id: number;
    prev_rank: string | null;
    next_rank: string | null;
  }) => {
    const res = await api.put(
      `/api/v1/secao-cliente/eventos/${data.eventoId}/kanban/cards/${data.cardId}/move`,
      { column_id: data.column_id, prev_rank: data.prev_rank, next_rank: data.next_rank },
      { headers },
    );
    return res.data;
  };

  return { getBoard, moveCard };
};
